// root '../../../';

// dependencies
import { Child } from 'pym.js';
import * as d3 from 'd3';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic
import { stylePremium } from './utils/helpers';

// styles
import './styles/graphic.scss';

/* develblock:start */
import meta from './data/meta.json';

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta)
      .forEach((id) => {
        const node = document.querySelector(`.${id}`);

        if (node) {
          node.innerHTML = meta[id];
        }
      });
  }

  const { pymChild } = window;
  pymChild.sendHeight();
};

function formatNum(num) {
  const str = num.toFixed(1).split('.');
  if (str[0].length >= 4) {
    str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1.');
  }
  return str.join(',');
}

const parseTime = d3.timeParse('%Y-%m-%d');
const formatTime = d3.timeFormat('%B %-d, %Y');
const fmtComma = d3.format(',');

function draw() {
  // let timeStamp;
  let voteCount;
  let daysUntil;
  d3.json('https://ix.cnn.io/data/early-voting-2024/national/total.latest.json').then((data) => {
    voteCount = data[0].election_cycles[0].data.ballots_cast.value;
    // timeStamp = d3.max([
    //   parseTime(data[0].election_cycles[0].data.ballots_cast_in_person.day.date),
    //   parseTime(data[0].election_cycles[0].data.ballots_cast_by_mail.day.date),
    // ]);
    // timeStamp = d3.min([
    //   timeStamp, new Date(),
    // ]);
    daysUntil = d3.max([
      data[0].election_cycles[0].data.ballots_cast_in_person.day.days_to_election,
      data[0].election_cycles[0].data.ballots_cast_by_mail.day.days_to_election,
    ]);

    daysUntil = d3.max([
      daysUntil, daysUntilElection(),
    ]);

    d3.select('#robotext').html(`<p class="moduleTitle"><span><i></i><i></i></span> VOTACIÓN ANTICIPADA EN EE.UU.</p><p><b>${formatNum(voteCount / 1000000)} millones</b><br>de estadounidenses ya han emitido su voto</p>`);
    pymChild.sendHeight();
  });
}


function daysUntilElection() {
  const t = new Date();
  const oneDay = 1000 * 60 * 60 * 24;
  const electionDay = new Date(2024, 10, 5);
  const today = new Date(t.getFullYear(), t.getMonth(), t.getDate());

  return Math.round((electionDay - today) / oneDay);
}
